






































































































































































































































































import Vue from "vue";
import Modifiers from "./Modifiers.vue";
import { mapState } from "vuex";
import {
  GET_MENU_DISHES,
  GET_MENU,
  GET_USER,
} from "@/queries/user/query.graphql";
import { UPDATE_DISH } from "@/queries/user/mutation.graphql";
import { toDate } from "@/utils/date";
export default Vue.extend({
  components: {
    Modifiers,
  },
  data() {
    return {
      debounced: null,
      user: null,
      dish: this.$store.getters["userModule/dish"],
      isLoading: false,
      time: {
        from: toDate("07:00", "h:m"),
        to: toDate("20:00", "h:m"),
      },
      showModifiers: false,
      dishQuery: null,
      // img: null,
      // selectedOption: { name: "All day long", code: "0" },
      price: null,
      options: [
        { name: "All day long", code: "0" },
        { name: "Custom", code: "1" },
      ],
    };
  },
  apollo: {
    user: {
      query: GET_USER,
      update: (data) => data.User[0],
    },
  },
  computed: {
    categoryId() {
      return this.$route.params.categoryId;
    },
    selectedOption: {
      get() {
        if (this.dish.availableFrom && this.dish.availableTo) {
          return { name: "Custom", code: "1" };
        } else {
          return { name: "All day long", code: "0" };
        }
      },
      set(val: any) {
        if (val.code === "1") {
          this.dish.availableFrom = "07:00:00";
          this.dish.availableTo = "20:00:00";
        } else {
          this.dish.availableFrom = null;
          this.dish.availableTo = null;
        }
        this.updateDish();
      },
    },
  },
  methods: {
    updateDish() {
      const { __typename, DishModifiers, ...rest } = this.dish;
      const variables = { ...rest };
      return this.$apollo.mutate({
        mutation: UPDATE_DISH,
        variables,
        update: (cache, { data: { update_Dish } }) => {
          if (update_Dish.affected_rows) {
            const dishData: any = cache.readQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: variables.id,
              },
            });

            dishData.Dish[0] = { ...dishData.Dish[0], ...this.dish };
            cache.writeQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: variables.id,
              },
              data: dishData,
            });
          }
        },
      });
    },
    initiateDish(route) {
      this.$apollo.addSmartQuery("dish", {
        query: GET_MENU_DISHES,
        variables: {
          dishId: this.$route.params.itemId,
        },
        watchLoading: (isLoading) => {
          this.isLoading = isLoading;
        },
        update: (data) => data.Dish[0],
        result: ({ data: { Dish }, loading, errors }) => {
          if (Dish) {
            this.$store.commit("userModule/updateDishModel", { ...Dish[0] });
            console.log(this.dish);
            // if (!this.isInitial) return;
            if (this.dish.availableFrom) {
              this.time.from = toDate(this.dish.availableFrom, "h:m");
            }
            if (this.dish.availableTo) {
              this.time.to = toDate(this.dish.availableTo, "h:m");
            }
            if (Dish[0].DishModifiers.length > 0) {
              this.showModifiers = true;
            } else this.showModifiers = false;
          }
        },
      });
    },
    changePrice(e) {
      if (e && this.price !== e) {
        this.price = e;

        this.debounced();
      }
    },
    save(val: string) {
      // if (val.trim().length === 0) {
      //   this.$toastr.e("You should insert one character at list!");
      //   return;
      // }
      this.dish.description = val;
      this.updateDish().then((data) => {
        this.dish.description = val;
      });
    },
    edit(value: string, callback: Function) {
      // this.value = value;
      if (value.trim().length === 0) {
        this.$toastr.e("You should insert one character at list!");
        return;
      }
      this.dish.name = value.trim();
      this.updateDish().then((data) => {
        callback();
      });
    },
    changeAvailabiltyTime(e) {
      if (this.time.from && typeof this.time.from !== "string") {
        this.dish.availableFrom = new Date(this.time.from).toLocaleTimeString(
          [],
          {
            hour12: false,
            hour: "2-digit",
            minute: "2-digit",
          }
        );
      }
      if (this.time.to && typeof this.time.to !== "string") {
        this.dish.availableTo = new Date(this.time.to).toLocaleTimeString([], {
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
        });
      }
      this.debounced();
    },
    upload(img: string) {
      this.dish.photoUrl = img;
      this.updateDish();
    },
    replace(img: string) {
      this.dish.photoUrl = img;
      this.updateDish();
    },
    remove(img: string) {
      this.dish.photoUrl = "";
      this.updateDish();
    },
  },
  mounted() {
    setTimeout(() => {
      // this.showModifiers = true;
    }, 4000);
  },
  created() {
    this.initiateDish(this.$route.name);
    this.debounced = this.$debounce(this.updateDish, 2000);
  },
  watch: {
    $route(to, from) {
      console.log("change");

      this.initiateDish(this.$route.name);
    },
  },
});
